import React from 'react';
const bonuses = [{
  title: 'Chair Fitness Master Vault™',
  description: 'A complete seated-exercise system including chair workouts, progressions, and ready-to-use classes.'
}, {
  title: 'Fall Prevention Pro™',
  description: 'Balance, stability, and fall-prevention protocols designed specifically for older adults.'
}, {
  title: 'Senior Games & Group Activities™',
  description: 'Hundreds of fun and engaging activities that increase participation and retention.'
}, {
  title: 'Active Aging Programs Vault™',
  description: '12 months of structured programming ready to implement.'
}, {
  title: 'Senior Fitness Business System™',
  description: 'Professional tools to organize, retain, and grow your senior fitness programs.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Save Hours Every Week',
  desc: 'Stop creating classes from scratch. Open the system, choose the session, and teach.'
}, {
  emoji: '👑',
  title: 'Greater Professional Confidence',
  desc: 'Know exactly what to teach, how to progress participants, and how to adapt classes safely.'
}, {
  emoji: '🦵',
  title: 'Better Participant Results',
  desc: 'Structured programs focused on mobility, balance, strength, and independence.'
}, {
  emoji: '😊',
  title: 'Higher Attendance & Retention',
  desc: 'Keep participants motivated with engaging sessions and progressive programming.'
}];
export function BonusSection() {
  return <>
      <section className="py-12 px-4 sm:px-6 bg-petrol text-white" data-id="element-15">
        <div className="text-center mb-10" data-id="element-16">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold mb-3 leading-tight uppercase text-gold" data-id="element-17">
            5 PREMIUM BONUSES INCLUDED
          </h2>
          <p className="text-lg sm:text-xl font-subheading font-bold text-ivory mb-2" data-id="element-18">
            Plus, you'll receive 5 premium bonuses
          </p>
          <p className="text-sm sm:text-base text-ivory/80 max-w-2xl mx-auto" data-id="element-19">
            Exclusive resources designed to save even more time and deliver
            better results.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto mb-10" data-id="element-20">
          {bonuses.map((bonus, i) => <div key={i} className={`bg-petrol-dark border border-gold/40 p-6 rounded-xl text-center shadow-lg ${i === 3 ? 'lg:col-start-1 lg:col-span-1 lg:translate-x-1/2' : ''} ${i === 4 ? 'lg:col-start-2 lg:col-span-1 lg:translate-x-1/2' : ''}`} data-id="element-21">
              <div className="inline-block bg-gold/20 text-gold font-body font-bold text-xs px-3 py-1.5 rounded mb-4 tracking-widest uppercase" data-id="element-22">
                🎁 BONUS {i + 1} — FREE
              </div>
              <h3 className="text-lg font-bold text-ivory mb-2 leading-tight font-heading" data-id="element-23">
                {bonus.title}
              </h3>
              <p className="text-sm text-ivory/80 leading-relaxed" data-id="element-24">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-25">
          <p className="inline-block font-body font-bold text-gold text-sm sm:text-base uppercase tracking-widest bg-gold/10 px-6 py-3 rounded-lg border border-gold/30" data-id="element-26">
            The 5 bonuses are FREE with your purchase today.
          </p>
        </div>
      </section>

      <section className="py-12 px-4 sm:px-6 bg-ivory border-b-4 border-cream" data-id="element-27">
        <h2 className="text-3xl sm:text-4xl font-heading font-bold text-center text-petrol mb-3 leading-tight uppercase" data-id="element-28">
          WHAT IS GOING TO CHANGE
        </h2>
        <p className="text-lg sm:text-xl font-subheading font-bold text-center text-sage mb-2" data-id="element-29">
          What will change in your professional life
        </p>
        <p className="text-sm sm:text-base text-center text-graphite mb-10 font-bold" data-id="element-30">
          Real benefits starting from your very first week:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-4xl mx-auto" data-id="element-31">
          {benefits.map((item, i) => <div key={i} className="bg-cream border-l-4 border-sage p-6 rounded-r-xl shadow-md flex gap-4 items-start hover:border-petrol transition-colors" data-id="element-32">
              <div className="text-3xl shrink-0 leading-none" data-id="element-33">{item.emoji}</div>
              <div data-id="element-34">
                <h3 className="text-base sm:text-lg font-bold text-petrol mb-2 uppercase tracking-wide font-body" data-id="element-35">
                  {item.title}
                </h3>
                <p className="text-graphite text-sm leading-relaxed" data-id="element-36">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}